
import * as React from 'react';

interface Props {
    startEpochInSecs: number;
    endEpochInSecs: number;
}

interface State {
    status? : string;
    className?: string;
    timerId?: number;
}

class GlanceTimeComponent extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    componentWillMount() {
        this.updateStatus();
    }


    componentDidMount() {
        let timerID : number = setInterval(() => this.updateStatus(), 1000 * 60);
        this.setState({
            ...this.state,
            timerId: timerID,
        });
    }

    componentWillUnmount() {
        clearInterval(this.state.timerId);
    }

    readableTime(duration: number) : string {
        let minHourDayMonthConst = 30 * 24 * 60 * 60;
        let result = '';
        result += (duration / minHourDayMonthConst >= 1 ? (Math.floor(duration / minHourDayMonthConst) + ' month(s) ') : '');
        duration = duration % minHourDayMonthConst;
        minHourDayMonthConst /= 30;
        
        result += (duration / minHourDayMonthConst >= 1 ? (Math.floor(duration / minHourDayMonthConst) + ' days(s) ') : '');
        duration = duration % minHourDayMonthConst;
        minHourDayMonthConst /= 24;

        result += (duration / minHourDayMonthConst >= 1 ? (Math.floor(duration / minHourDayMonthConst) + ' hour(s) ') : '');
        duration = duration % minHourDayMonthConst;
        minHourDayMonthConst /= 60;

        result += (duration / minHourDayMonthConst >= 1 ? (Math.floor(duration / minHourDayMonthConst) + ' minute(s) ') : '');
        duration = duration % minHourDayMonthConst;
        minHourDayMonthConst /= 60; 

        return result;

    }

    updateStatus() {
        const currentdate = new Date();
        const currentdateEpochInSecs : number = Math.floor(currentdate.getTime() / 1000);// - currentdate.getTimezoneOffset() * 60        
        if (currentdateEpochInSecs < this.props.startEpochInSecs) {
            const diff = this.props.startEpochInSecs - currentdateEpochInSecs;
            this.setState({
                status : 'Active in ' + this.readableTime(diff),
                className : 'future',
            });
        } else if (currentdateEpochInSecs >= this.props.startEpochInSecs && currentdateEpochInSecs <  this.props.endEpochInSecs) {
            const diff = this.props.endEpochInSecs - currentdateEpochInSecs;
            this.setState({
                status : 'Expires in ' + this.readableTime(diff),
                className: 'present',
            });
        } else if (currentdateEpochInSecs > this.props.endEpochInSecs) {
            const diff = currentdateEpochInSecs - this.props.endEpochInSecs;
            this.setState({
                status : 'Expired since ' + this.readableTime(diff),
                className : 'past',
            });
        }
    }

    render() {
        return (
            <span className={this.state.className}>{this.state.status}</span>
        );
    }
}

export default GlanceTimeComponent;



// WEBPACK FOOTER //
// ./src/components/GlanceTime.tsx